const DEFAULT_SITE_URL = 'https://www.yourlifeanchor.com'

/** Canonical production origin (www). Used for canonical links, OG URLs, and JSON-LD. */
export function getSiteUrl(): string {
  const fromEnv = import.meta.env.VITE_PUBLIC_URL as string | undefined
  return (fromEnv ?? DEFAULT_SITE_URL).replace(/\/$/, '')
}

/** Build an absolute canonical URL for a path on the public site. */
export function canonicalUrl(path: string = '/'): string {
  const base = getSiteUrl()
  if (!path || path === '/') return `${base}/`
  return `${base}${path.startsWith('/') ? path : `/${path}`}`
}
